<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">13</h2>
<p class="vers"><span>Das Lied</span>, das ich kam zu
singen,<br class="calibre1"/>
bleibt ungesungen bis auf diesen Tag.</p>
<p class="vers">Ich brachte meine Tage hin, mein Instrument<br class="calibre1"/>
zu stimmen und umzustimmen.</p>
<p class="vers">Der Takt kam nicht aus, die Worte<br class="calibre1"/>
sind nicht recht gesetzt, nur eine Pein<br class="calibre1"/>
des Wünschens ist im Herzen.</p>
<p class="vers">Die Blüte hat sich nicht geöffnet, nur<br class="calibre1"/>
der Wind seufzt vorüber.</p>
<p class="vers">Ich habe sein Angesicht nicht gesehn,<br class="calibre1"/>
nicht gelauscht seiner Stimme; nur seinen<br class="calibre1"/>
leisen Fußtritt hab ich gehört auf der<br class="calibre1"/>
Straße vor meinem Hause.</p>
<p class="vers">Der lange Tag verging damit, ihm den<br class="calibre1"/>
Sitz am Boden zu breiten, die Lampe<br class="calibre1"/>
aber ist noch nicht entzündet, ich kann<br class="calibre1"/>
ihn nicht in mein Haus bitten.</p>
<p class="vers">Ich lebe der Hoffnung ihn zu treffen,<br class="calibre1"/>
doch dieses Treffen ist noch nicht. <a id="page18" title="mabarosa/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0014.vue?f2dfc0f6